<template>

	<div class="contact_us">
		<div class="contact_us_content container">
			<img  :src="require(`@/assets/images/logo/NYI-Logo-White.svg`)" alt="" />
			<h2>NEW YORK ISLANDERS</h2>

			<button type="button" name="button"
				@click="modalActive = true"
                @click.prevent="(e) => $emit('modalShow', 'show')">
				Join Us
			</button>
			<p class="terms">
				Season tickets are subject to the Season Ticket Holder Terms and Conditions available
				<a href="http://nhl.bamcontent.com/images/assets/binary/345261670/binary-file/file.pdf" target="_blank">here</a>.
			</p>
			<p class="additional_que">HAVE QUESTIONS about next season<span>?</span>
				<br/>
				Please reach out and we would be happy to assist.</p>

			<div class="copy">

				<div class="text" >

					<div class="contact-info">
						<p><a style="color:#F16924 !important;" href="tel:888-694-7537">P: 888-694-7537 </a></p>
						<p><a style="color:#F16924 !important;" href="mailto:memberships@newyorkislanders.com">E: memberships@newyorkislanders.com</a></p>
					</div>


				</div>
			</div>

		</div>
	</div>
</template>

<script>

</script>

<style lang="scss" scoped>

	.contact_us {
		background: theme-var($--ch-theme-primary);
		display: flex;
		position: relative;
		h2 {
			font-family: "GeogrotesqueSharp-ExpBd";
			font-size: 34px;
			color:  theme-var($--ch-theme-on-primary);
			letter-spacing: 0;
			text-align: center;
			line-height: 34px;
			font-weight: 700;
			padding-top:20px;
			@include media-breakpoint-down(sm) {
				font-size: 12px;
			}
		}
		button{
			text-transform: uppercase;
		    margin: 20px 0;
		    width: 230px;
		    text-decoration: none;
		    display: flex;
		    justify-content: center;
		    background-color: var(--ch-theme-secondary);
		    border: none;
		    padding: 10px 25px;
		    color: #fff;
		    font-family: "GeogrotesqueSharp-Md";
		    font-size: 28px;
		    letter-spacing: 0;
		    text-align: center;
		    font-weight: 500;
		    transition: all .25s ease-in-out;
			&:hover {
				background: #ffffff;
				color: theme-var($--ch-theme-primary);

			}
		}
		.terms{
			font-family: "GeogrotesqueSharp-Md";
			font-size: 16px;
			margin-bottom: 10px;
		}
		&_content {
			display:flex;
			flex-direction:column;
			align-items: center;
			margin-block: 5vh;
			@include media-breakpoint-down(sm) {
				padding:10px 15px;
			}
			@media only screen and (min-width: 578px) and (max-width: 900px)  {
				padding:60px 15px 20px 15px;
			}
			z-index: 1;
			@include media-breakpoint-up(xl) {
				max-width: 890px;
			}
			p{
				font-family: "GeogrotesqueSharp-Bd";
				font-size: 22px;
				color:  theme-var($--ch-theme-on-primary);
				letter-spacing: 0;
				text-align: center;
				line-height: 120%;
				font-weight: 700;
			}
			.additional_que{
				padding: 10px 0px;
				line-height: 150%;
				text-transform:uppercase;

			}
			.copy {
				//margin-top:30px;
				text-align:center;
				@include media-breakpoint-down(sm) {
				}

				.text {
					text-align:center;
					//margin-top:30px;

					p{
						// padding-top:5px;
						font-family: "GeogrotesqueSharp-Md";
						font-size: 18px;
						margin-bottom:5px;
						font-weight: 400;
						//text-transform:uppercase;
						color:  theme-var($--ch-theme-secondary);
						a{
							text-decoration:none;
							//text-transform:lowercase;
							color:  theme-var($--ch-theme-secondary);
						}
					}
					.contact-info{
						//display: flex;
						//justify-content:space-evenly;

						a{
							margin-right:10px;
						}
						@include media-breakpoint-down(sm) {
							//flex-direction: column;
						}

					}
				}

			}


		}
	}
</style>
